export function questionIsVisible(question, answers = {}, category = null) {
  const conditions = question?.show_if;
  if (!conditions || typeof conditions !== "object") return true;

  return Object.entries(conditions).every(([key, expected]) => {
    const actual = key === "category" ? category : answers[key];
    if (Array.isArray(actual)) {
      return Array.isArray(expected)
        ? expected.some((value) => actual.includes(value))
        : actual.includes(expected);
    }
    return Array.isArray(expected) ? expected.includes(actual) : actual === expected;
  });
}